let textToExport;

if (process.env.VUE_APP_THEME === 'SINGAPORE_DEMO') {
  textToExport = () => import('./singapore/terms-and-condition-text.vue');
} else if (process.env.VUE_APP_THEME === 'AMEX') {
  textToExport = () => import('./amex/terms-and-condition-text.vue');
} else {
  textToExport = () => import('./mobi/terms-and-condition-text.vue');
}

export default textToExport;
